import { render } from "./SettingsView.vue?vue&type=template&id=219d8edb"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "219d8edb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('219d8edb', __exports__)) {
    api.reload('219d8edb', __exports__)
  }
  
  module.hot.accept("./SettingsView.vue?vue&type=template&id=219d8edb", () => {
    api.rerender('219d8edb', render)
  })

}


export default __exports__